<template>
<section class="section-border border-primary">
    <div class="container d-flex flex-column">
        <div class="row align-items-center justify-content-center gx-0 min-vh-100">
            <div class="col-8 col-md-6 col-lg-7 offset-md-1 order-md-2 mt-auto mt-md-0 pt-12 pb-4 py-md-11">
                <img src="/assets/img/illustrations/illustration-1.png" alt="..." class="img-fluid">
            </div>
            <div class="col-12 col-md-5 col-lg-4 order-md-1 mb-auto mb-md-0 pb-8 py-md-11">
                <h1 class="display-3 fw-bold text-center">404</h1>
                <p class="mb-5 text-center text-muted">It looks like this page no longer exists</p>
                <div class="text-center">
                    <a class="btn btn-primary" href="/">Home</a>
                </div>
            </div>
        </div>
    </div>
</section>
</template>
